/**
 * Geld wird IMMER in ganzen Cent als Integer geführt — niemals als Float.
 * Das vermeidet Rundungsfehler (0.1 + 0.2 !== 0.3) bei Summen und Splits.
 */

/** Betrag in ganzen Cent (Integer). Branded type, damit Cent nicht mit Euro-Floats verwechselt wird. */
export type Cents = number & { readonly __brand: "Cents" };

export function cents(value: number): Cents {
  if (!Number.isInteger(value)) {
    throw new Error(`Cents müssen ganzzahlig sein, erhalten: ${value}`);
  }
  return value as Cents;
}

/** Aus Euro (z. B. 12.50) verlustfrei in Cent runden. */
export function eurToCents(euro: number): Cents {
  return cents(Math.round(euro * 100));
}

export function addCents(...values: Cents[]): Cents {
  return cents(values.reduce((sum, v) => sum + v, 0));
}

export function mulCents(amount: Cents, qty: number): Cents {
  return cents(Math.round(amount * qty));
}

/** Formatiert Cent als lokalisierten Währungsstring, z. B. 1250 → "12,50 €". */
export function formatMoney(amount: Cents, currency = "EUR", locale = "de-AT"): string {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount / 100);
}

/** Steuersatz als Prozent-Integer (Österreich: 0, 10, 13, 20). */
export type TaxRate = 0 | 10 | 13 | 20;

/** Herausgerechnete Steuer aus einem Bruttobetrag (Beleg/Z-Bericht). */
export function taxFromGross(gross: Cents, rate: TaxRate): Cents {
  if (rate === 0) return cents(0);
  return cents(Math.round((gross * rate) / (100 + rate)));
}
